import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import retardUpdate from '../../../lib/react/update-retarder';
import OEPopover from '../../views/oe-popover';
import {OEObjectModelValueEditHelper} from '../../elements/object-model-value-edit/oe-object-model-value-edit-model';
import {OESmartAttributeProps} from './smart-attribute/oe-smart-attribute-model';
import OESmartAttributeController from './smart-attribute/oe-smart-attribute-controller';
import {OENoteAttributeHelper} from './oe-note-attribute-model';
import {OEFunctionFragmentParameterModel} from './function/oe-function-model';
import {OESmartAttributeChangeFlags} from './smart-attribute/oe-smart-attribute-model';

export class OENoteAttributeController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = typeof(this.props.id) === 'number' ? this.props.id : null;
        
        this.attributes = undefined;

        this.state = {
            id:                 this.id,
            attributes:         undefined
        };

        this.onNoteAttributeAdded = this.onNoteAttributeAdded.bind(this);
        this.onNoteAttributeRemoved = this.onNoteAttributeRemoved.bind(this);
        this.onNoteAttributeUserRefChanged = this.onNoteAttributeUserRefChanged.bind(this);
        this.onNoteAttributeParamsChanged = this.onNoteAttributeParamsChanged.bind(this);
        this.onNoteAttributeEventFunctionChanged = this.onNoteAttributeEventFunctionChanged.bind(this);

        this.onAttributeAddRequest = this.onAttributeAddRequest.bind(this);
        this.onAttributeRemoveRequest = this.onAttributeRemoveRequest.bind(this);
        this.onAttributeChangeRequest = this.onAttributeChangeRequest.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAttributeAdded, this.onNoteAttributeAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAttributeRemoved, this.onNoteAttributeRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAttributeUserRefChanged, this.onNoteAttributeUserRefChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAttributeParamsChanged, this.onNoteAttributeParamsChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteAttributeEventFunctionChanged, this.onNoteAttributeEventFunctionChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAttributeAdded, this.onNoteAttributeAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAttributeRemoved, this.onNoteAttributeRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAttributeUserRefChanged, this.onNoteAttributeUserRefChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAttributeParamsChanged, this.onNoteAttributeParamsChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteAttributeEventFunctionChanged, this.onNoteAttributeEventFunctionChanged);
    }

    componentWillReceiveProps(nextProps)    {
        if(nextProps.id !== this.id)   {
            this.updateID(nextProps.id);
        }
    }

    updateID(id)    {
        if(typeof(id) !== 'number')  id = null;
        if(this.id === id)   return;
        this.id = id;
        this.setState({id: this.id});
        this.updateAttributes();
    }

    updateAttributes()  {
        let attributes = undefined;

        if(this.id !== null && this.oe.isReady())  {
            let ids = this.oe.sharedInterface.getUIControllerNote().getNoteAttributeIDs(this.id);
            attributes = ids.map(id => this.oe.sharedInterface.getUIControllerNote().getNoteAttributeDataID(this.id, id));
        }

        this.attributes = attributes;
        this.setState({attributes: clone(this.attributes)});
    }

    onNoteAttributeAdded(message, userInfo)   {
        if(userInfo.ID !== this.id || this.attributes === undefined)  return;

        let attribute = this.oe.sharedInterface.getUIControllerNote().getNoteAttributeDataID(this.id, userInfo.attributeID);
        if(!attribute)  return;
        this.attributes.splice(userInfo.attribute, 0, attribute);
        this.setState({attributes: clone(this.attributes)});
    }

    onNoteAttributeRemoved(message, userInfo)   {
        if(userInfo.ID !== this.id || this.attributes === undefined)  return;

        let index = this.attributes.findIndex(attribute => attribute.id === userInfo.attributeID);
        if(index < 0)   return;
        this.attributes.splice(index, 1);
        this.setState({attributes: clone(this.attributes)});
    }

    onNoteAttributeUserRefChanged(message, userInfo)   {
        if(userInfo.ID !== this.id || this.attributes === undefined)  return;

        let attribute = this.attributes.find(attribute => attribute.id === userInfo.attributeID);
        if(!attribute)  return;

        let userRef = this.oe.sharedInterface.getUIControllerNote().getNoteAttributeUserRefID(this.id, userInfo.attributeID);
        attribute.userRef = userRef;
        this.setState({attributes: clone(this.attributes)});
    }

    onNoteAttributeParamsChanged(message, userInfo)   {
        if(userInfo.ID !== this.id || this.attributes === undefined)  return;

        let attribute = this.attributes.find(attribute => attribute.id === userInfo.attributeID);
        if(!attribute)  return;

        let params = this.oe.sharedInterface.getUIControllerNote().getNoteAttributeParamsID(this.id, userInfo.attributeID);
        attribute.params = params;
        this.setState({attributes: clone(this.attributes)});
    }

    onNoteAttributeEventFunctionChanged(message, userInfo)   {
        if(userInfo.ID !== this.id || this.attributes === undefined)  return;

        let attribute = this.attributes.find(attribute => attribute.id === userInfo.attributeID);
        if(!attribute)  return;

        let func = this.oe.sharedInterface.getUIControllerNote().getNoteAttributeEventFunctionDescID(this.id, userInfo.attributeID, userInfo.eventName);
        attribute.events[userInfo.event].function = func;

        this.setState({attributes: clone(this.attributes)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.attributes = undefined;
            this.setState({attributes: undefined});
            return;
        }

        retardUpdate(this, () => {
            this.updateAttributes();
        });
    }

    render() {
        return  (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OESmartAttributeController
                    {...this.props}
                    attributes={this.state.attributes}
                    iconForType={OENoteAttributeHelper.iconForType}
                    parameterModelForType={OENoteAttributeHelper.parameterModelForType}
                    onAttributeAddRequest={this.onAttributeAddRequest}
                    onAttributeRemoveRequest={this.onAttributeRemoveRequest}
                    onAttributeChangeRequest={this.onAttributeChangeRequest}
                />
            </React.Fragment>
        );
    }

    onAttributeAddRequest(sender, type)   {
        if(!this.oe.isReady() || this.id === null)  return;
        this.oe.sharedInterface.getUIControllerNote().addNoteAttribute(this.id, type);
    }

    onAttributeRemoveRequest(sender, id)   {
        if(!this.oe.isReady() || this.id === null)  return;
        this.oe.sharedInterface.getUIControllerNote().removeNoteAttributeID(this.id, id);
    }

    onAttributeChangeRequest(sender, attribute, changeFlags, eventIndex)    {
        if(!this.oe.isReady() || this.id === null)  return;

        let note = this.oe.sharedInterface.getUIControllerNote();

        //
        if(changeFlags & OESmartAttributeChangeFlags.userRef)   {
            note.setNoteAttributeUserRefID(this.id, attribute.id, attribute.userRef);
        }

        //
        if(changeFlags & OESmartAttributeChangeFlags.params)   {
            let params = clone(attribute.params);
            if(params)  params.$__model__ = OEObjectModelValueEditHelper.modelToCoreDictModel(OENoteAttributeHelper.parameterModelForType(attribute.type));
            note.setNoteAttributeParamsID(this.id, attribute.id, params);
        }

        //
        if(typeof(eventIndex) === 'number' && (changeFlags & OESmartAttributeChangeFlags.eventFunc))   {
            let event = attribute.events[eventIndex];

            let func = clone(event.function);
            if(func && func.fragments)  {
                func.fragments.forEach(fragment => {
                    if(fragment.params) fragment.params.$__model__ = OEObjectModelValueEditHelper.modelToCoreDictModel(OEFunctionFragmentParameterModel.modelForType(fragment.type));
                });
            }
            note.setNoteAttributeFunctionDescID(this.id, attribute.id, event.name, func);
        }
    }
}

OENoteAttributeController.defaultProps = {
    moduleId:                       '',
    className:                      'note-attribute-controller',
    disabled:                       false,
    addAttributeMenuTypes:          OENoteAttributeHelper.addAttributeMenuTypes,
    addEventFunctionMenuTypes:      OENoteAttributeHelper.addEventFunctionMenuTypes
};

OENoteAttributeController.propTypes = {
    moduleId:                       PropTypes.string,
    className:                      PropTypes.string,
    id:                             PropTypes.number,
    addAttributeMenuTypes:          OESmartAttributeProps.addAttributeMenuTypes,
    addEventFunctionMenuTypes:      OESmartAttributeProps.addEventFunctionMenuTypes
};

//
export const OENoteAttributePopoverController = OEPopover.coat(OENoteAttributeController, {
    noHeader:               true,
}, {
    placement:              'right',
    buttonClassName:        'transparent-btn',
    controllerClassName:     'note-attribute-popover compact'
});